export const EntityViewProperties = `
    geoType
    type
    fullUid
    layername
    layerid
    name
    membertype
    websiteurl
    notes
    instruc
    datelastchanged
    address
    city
    state
    zip
`;
